import { routeConfig } from "@/routes/route";
import { lazy, Suspense } from "react";

const LazyLoad = (path: string) => {
  const Comp = lazy(() => import("@LeadGen/" + path));
  return (
    <Suspense fallback={<></>}>
      <Comp />
    </Suspense>
  );
};
export const MSNbillingRouter: routeConfig[] = [
  {
    path: "/billing",
    element: LazyLoad("BillingSummary/index"),
    name: "Billing Summary",
    key: "accountManagement",
    icon: "billing-svg",
    children: [
      {
        path: "billingReport",
        name: "Billing Report",
        key: "billingReport",
        element: LazyLoad("BillingSummary/Report/index"),
      },
      {
        path: "billingReport/edit",
        name: "Edit Billing Report",
        key: "Edit Billing Report",
        element: LazyLoad("BillingSummary/Report/edit"),
        isHidden: true
      },
      {
        path: "billingReport/billingSummary",
        name: "Billling Summary",
        key: "billlingSummary",
        element: LazyLoad("BillingSummary/Report/billingSummary"),
        isHidden: true
      },
      {
        path: "accrualReport",
        name: "Accrual Report",
        key: "AccrualReport",
        element: LazyLoad("BillingSummary/AccrualReport/index"),
      },
      {
        path: "accrualReport/edit",
        name: "Edit Accrual Report",
        key: "Edit Accrual Report",
        element: LazyLoad("BillingSummary/AccrualReport/edit"),
        isHidden: true
      },
      {
        path: "accrualReport/billingSummary",
        name: "Billling Summary",
        key: "billlingSummary",
        element: LazyLoad("BillingSummary/AccrualReport/billingSummary"),
        isHidden: true
      },
    ],
  }
];
